module.exports = __webpack_public_path__ + "static/media/s3.c9af9182.png";